import $ from 'jquery'
import MobileDetect from 'mobile-detect'
import {isEmpty} from './Helpers'
import {
    EVENT_ORIENTATION_CHANGE,
    EVENT_WINDOW_RESIZE
} from './Paramaters';


export default class UserDevice {

	constructor(data) {
		this._data = Object.assign({}, data)
		if (Object.keys(this._data).length === 0) {
			this._data.md = new MobileDetect(window.navigator.userAgent)
			this._data.mobile = !isEmpty(this.md.mobile())
			this._data.phone = !isEmpty(this.md.phone())
			this._data.tablet = !isEmpty(this.md.tablet())
			this._data.iOS = this.md.is('iOS')
            this._data.orientation = window.innerHeight > window.innerWidth ? 'potrait' : 'landscape'

        }
		this.init()
	}

	/** @return {MobileDetect} */
	get md() { return this._data.md}

	/** @param {MobileDetect} value*/
	set md(value) { this._data.md = value }

	/** @return {boolean} */
	get mobile() { return this._data.mobile
	}

	/** @param {boolean} value*/
	set mobile(value) {
		this._data.mobile = value
	}

	/** @return {boolean} */
	get tablet() { return this._data.tablet}

	/** @param {boolean} value*/
	set tablet(value) {
		this._data.tablet = value
	}

	/** @return {boolean} */
	get phone() { return this._data.phone}

	/** @param {boolean} value*/
	set phone(value) {
		this._data.phone = value
	}

	/** @return {boolean} */
	get iOS() { return this._data.iOS}

	/** @param {boolean} value*/
	set iOS(value) { this._data.iOS = value }

    /** @return {string} */
    get orientation() { return this._data.orientation}

    /** @param {string} value*/
    set orientation(value) { this._data.orientation = value;
        $(document.body.parentElement).toggleClass('potrait', value==='potrait')
        $(document.body.parentElement).toggleClass('landscape', value==='landscape')
        $(window).trigger(EVENT_ORIENTATION_CHANGE)
    }

	init() {
		$(document.body.parentElement).toggleClass('mobile', this.mobile)
			.toggleClass('tablet', this.tablet)
			.toggleClass('phone', this.phone)

        $(window).on("orientationchange", ()=> {
            setTimeout(()=>{
                this.orientation = window.innerHeight > window.innerWidth ? 'potrait' : 'landscape'
            },150)
        });

        $(window).on("resize", ()=> {
            $(window).trigger(EVENT_WINDOW_RESIZE)
        });

	}


    mediaCheck(options) {
        var mq;

        function mqChange(mq, options) {
            if (mq.matches) {
                if (typeof options.entry === "function") {
                    options.entry();
                }
            } else if (typeof options.exit === "function") {
                options.exit();
            }
        };

        mq = window.matchMedia(options.media);

        mq.addListener(function() {
            mqChange(mq, options);
        });

        mqChange(mq, options);
    };


}

